var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import tracking from "@irati-tracking/wallet/tenantWallet";
import { hangPromise } from "@irati/utils/promise";
import Loading from "@irati/ui/src/Loading";
import History from "@irati/utils/history";
import topupService from "@irati/wallet/services/TopUp";
import ErrorCard from "./ErrorCard";
import CardConfirmationPopUp from "./CardConfirmationPopUp";
var ConfirmTenantWalletTopUpPage = /** @class */ (function (_super) {
    __extends(ConfirmTenantWalletTopUpPage, _super);
    function ConfirmTenantWalletTopUpPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isError: false,
            showCompletionModal: false,
            load: hangPromise()
        };
        _this.goBackToTransactions = function () {
            History.push({
                pathname: "/wallet/tenant"
            });
        };
        _this.handleTryAgain = function () {
            var tenantWalletTopup = _this.state.tenantWalletTopup;
            History.push({
                pathname: "/wallet/tenant/top-up",
                tenantWalletTopup: tenantWalletTopup
            });
        };
        return _this;
    }
    ConfirmTenantWalletTopUpPage.prototype.componentDidMount = function () {
        var _this = this;
        var tenantWalletTopupId = this.props.match.params.tenantWalletTopupId;
        var load = topupService.complete(tenantWalletTopupId).then(function (topUp) {
            tracking.completeTenantWalletTopUp();
            _this.setState({ showCompletionModal: true, tenantWalletTopup: topUp });
        }).catch(function () {
            _this.setState({ isError: true });
        });
        this.setState({ load: load });
    };
    ConfirmTenantWalletTopUpPage.prototype.render = function () {
        var _a = this.state, isError = _a.isError, showCompletionModal = _a.showCompletionModal, tenantWalletTopup = _a.tenantWalletTopup, load = _a.load;
        if (isError) {
            return React.createElement(ErrorCard, { goBackToTransactions: this.goBackToTransactions, handleTryAgain: this.handleTryAgain });
        }
        if (showCompletionModal) {
            return (React.createElement(CardConfirmationPopUp, { tenantWalletTopup: tenantWalletTopup, goBackToTransactions: this.goBackToTransactions, showCompletionModal: showCompletionModal }));
        }
        return (React.createElement(Loading, { load: load }));
    };
    return ConfirmTenantWalletTopUpPage;
}(Component));
export default ConfirmTenantWalletTopUpPage;
